 import { Injectable, inject } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { map, take, filter } from 'rxjs/operators';
import { selectCurrentPortal, selectIsAuthenticated } from '../ngrx/auth/auth.selectors';
import { AuthService } from '../services/auth/auth.service';
import { combineLatest } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PortalRedirectGuard implements CanActivate {
  private store = inject(Store);
  private router = inject(Router);
  private authService = inject(AuthService);

  canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    // Only apply portal redirect for the root route
    if (route.routeConfig?.path !== '') {
      return Promise.resolve(true);
    }

    return new Promise((resolve) => {
      // Wait for auth state to be ready
      this.authService.authStateReady$.pipe(
        filter(ready => ready),
        take(1)
      ).subscribe(() => {
        // Get current portal and auth state
        combineLatest([
          this.store.select(selectCurrentPortal),
          this.store.select(selectIsAuthenticated)
        ]).pipe(
          take(1)
        ).subscribe(([portal, isAuthenticated]) => {
          
          if (!isAuthenticated) {
            // Not authenticated, allow normal routing (will show frontpage)
            resolve(true);
            return;
          }

          // User is authenticated, redirect to portal's default page
          let redirectPath = '/';
          
          switch (portal) {
            case 'administration':
              redirectPath = '/dashboard';
              break;
            case 'user':
              redirectPath = '/profile';
              break;
            case 'external':
              redirectPath = '/profile';
              break;
            default:
              // Unknown portal, allow normal routing
              resolve(true);
              return;
          }

          this.router.navigate([redirectPath], { replaceUrl: true });
          resolve(false); // Prevent original route activation
        });
      });
    });
  }
} 